import AnchorComponent from "../components/anchor";
import ButtonComponent from "../components/button";
import CounterComponent from "../components/counter";
import {setCountCartHeader} from "../init-cart";
import {setAddCart} from "../require/set-add-cart";
import {setReduceCart} from "../require/set-reduce-cart";
import {RenderPosition, render} from "../utils/render";

export default class CommerceController {
  constructor({container, className, itemId = ``, count = 0}) {
    this._container = container;
    this._className = className;
    this._itemId = itemId;
    this._count = count;

    this._counterComponent = null;

    this._onCartButtonClickHandler = this._onCartButtonClickHandler.bind(this);
    this._onAddButtonClickHandler = this._onAddButtonClickHandler.bind(this);
    this._onDeleteButtonClickHandler = this._onDeleteButtonClickHandler.bind(this);
  }

  render() {
    if (!this._itemId) {
      return;
    }

    this._container.dataset.inCart = this._count !== 0;

    this._renderCartButton(this._container);
    this._renderCounter(this._container);
    this._renderCartLink(this._container);
  }

  _renderCartButton(container) {
    const button = new ButtonComponent({
      className: `items__itemAddButton`,
      title: `В корзину`,
      prompt: `Добавить в корзину`,
    });

    button.setClickHandler(this._onCartButtonClickHandler);

    render(container, button.getElement(), RenderPosition.BEFOREEND);
  }

  _renderCounter(container) {
    this._counterComponent = new CounterComponent({
      className: this._className,
      count: this._count,
    });

    this._counterComponent.setAddButtonClickHandler(this._onAddButtonClickHandler);
    this._counterComponent.setDeleteButtonClickHandler(this._onDeleteButtonClickHandler);

    render(container, this._counterComponent.getElement(), RenderPosition.BEFOREEND);
  }

  _renderCartLink(container) {
    const link = new AnchorComponent({
      className: `items__itemCartButton`,
      // className: `items__itemCartButton button-primary`,
      title: `Оформить`,
      link: `/cart`
    });

    render(container, link.getElement(), RenderPosition.BEFOREEND);
  }

  _setActiveContainer(count = 0) {
    this._container.dataset.inCart = count > 0;
  }

  _setCounter(count) {
    this._counterComponent.count = count;
  }

  _addCart(count) {
    setAddCart(this._itemId, (response) => {
      setCountCartHeader(response.cart_count);
      this._setActiveContainer(count);
      this._setCounter(count);
    });
  }

  _deleteCart(count) {
    setReduceCart(this._itemId, (response) => {
      setCountCartHeader(response.cart_count);
      this._setActiveContainer(count);
      this._setCounter(count);
    });
  }

  _onCartButtonClickHandler() {
    this._addCart(1);
  }

  _onAddButtonClickHandler(count) {
    this._addCart(count);
  }

  _onDeleteButtonClickHandler(count) {
    this._deleteCart(count);
  }
}

